/* ------------------------------------------------------------------------------------------------
   preorder-countdown.js — Copbusters
   ------------------------------------------------------------------------------------------------
   Gestisce il blocco "Countdown preordine" della pagina prodotto.

   PERCHÉ LA LOGICA È QUI E NON IN LIQUID
   La CDN di Shopify cachea la pagina intera: un confronto data > 'now' fatto in Liquid resterebbe
   congelato al momento della generazione della cache. Il Liquid emette quindi solo la data target
   (attributo data-preorder-date, formato YYYY-MM-DD); tutto il calcolo di stato avviene qui.

   REGOLA DI USCITA
   L'uscita è fissata a mezzanotte (00:00) ora di Roma del giorno indicato nel metafield.
   A data superata il blocco viene rimosso dal DOM (sul sito pubblico). Nel Theme Editor resta
   visibile con un messaggio di avviso, altrimenti il merchant non capirebbe perché è sparito.

   NOTA: romeParts/romeWallToUTC replicano l'approccio già usato in assets/countdown-jp.js.
   Sono duplicati volutamente (nessuna dipendenza fra i due file): se un giorno si centralizzano,
   esportare romeWallToUTC su window.CopbustersJP e sostituire qui le due funzioni.
   ------------------------------------------------------------------------------------------------ */

(function () {
  'use strict';

  var TZ = 'Europe/Rome';
  var SELECTOR = '[data-preorder-countdown]';
  var TICK_MS = 30000;

  /* Parti "a muro" della data in Italia, con gestione automatica di CET/CEST. */
  function romeParts(date) {
    var dtf = new Intl.DateTimeFormat('en-US', {
      timeZone: TZ,
      hour12: false,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });

    var out = {};
    dtf.formatToParts(date).forEach(function (part) {
      if (part.type !== 'literal') out[part.type] = parseInt(part.value, 10);
    });

    if (out.hour === 24) out.hour = 0; // alcuni engine restituiscono 24 per la mezzanotte
    return out;
  }

  function romeOffsetMs(date) {
    var p = romeParts(date);
    var asUTC = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
    return asUTC - date.getTime();
  }

  /* Converte un orario "muro" romano nell'istante UTC corrispondente (stima + correzione). */
  function romeWallToUTC(y, mo, d, h, mi) {
    var guess = Date.UTC(y, mo - 1, d, h, mi, 0);
    var offset = romeOffsetMs(new Date(guess));
    offset = romeOffsetMs(new Date(guess - offset));
    return guess - offset;
  }

  /* Indice del giorno di calendario, per contare i giorni "veri" e non le finestre di 24h. */
  function dayIndex(y, mo, d) {
    return Date.UTC(y, mo - 1, d) / 86400000;
  }

  function fill(template, n) {
    return String(template || '').replace(/\{n\}/g, n);
  }

  function retire(el) {
    if (el.getAttribute('data-design-mode') === 'true') {
      var output = el.querySelector('[data-preorder-text]');
      el.setAttribute('data-state', 'expired');
      el.removeAttribute('hidden');
      if (output) output.textContent = el.getAttribute('data-tpl-expired') || '';
      return;
    }

    if (el.parentNode) el.parentNode.removeChild(el);
  }

  function init(el) {
    if (el.__preorderInit) return;
    el.__preorderInit = true;

    var match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(el.getAttribute('data-preorder-date') || '');
    var output = el.querySelector('[data-preorder-text]');

    if (!match || !output) {
      retire(el);
      return;
    }

    var ty = parseInt(match[1], 10);
    var tmo = parseInt(match[2], 10);
    var td = parseInt(match[3], 10);

    var target = romeWallToUTC(ty, tmo, td, 0, 0);
    var targetDay = dayIndex(ty, tmo, td);
    var timer = null;

    function render() {
      var now = new Date();
      var diff = target - now.getTime();

      if (diff <= 0) {
        if (timer) clearInterval(timer);
        retire(el);
        return;
      }

      var p = romeParts(now);
      var delta = targetDay - dayIndex(p.year, p.month, p.day);
      var text;

      if (delta >= 2) {
        text = fill(el.getAttribute('data-tpl-days'), delta);
      } else if (delta === 1) {
        text = el.getAttribute('data-tpl-tomorrow');
      } else {
        var hours = Math.floor(diff / 3600000);

        if (hours >= 2) {
          text = fill(el.getAttribute('data-tpl-hours'), hours);
        } else if (hours === 1) {
          text = el.getAttribute('data-tpl-hour-one');
        } else {
          var minutes = Math.max(1, Math.ceil(diff / 60000));
          text = minutes === 1
            ? el.getAttribute('data-tpl-minute-one')
            : fill(el.getAttribute('data-tpl-minutes'), minutes);
        }
      }

      output.textContent = text || '';
      el.setAttribute('data-state', 'upcoming');
      el.removeAttribute('hidden');
    }

    render();
    timer = setInterval(render, TICK_MS);

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) render();
    });
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    Array.prototype.forEach.call(root.querySelectorAll(SELECTOR), init);
  }

  function boot() {
    scan(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* <product-rerender> rigenera il markup del prodotto al cambio variante: il blocco può essere
     reinserito nel DOM dopo il primo boot. Stesso pattern di card-quickbuy-portal.js. */
  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(SELECTOR)) init(node);
          scan(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', boot);
})();